export const isLoadingSelector = state => state.communityComments.get('isLoading');
export const commentsSelector = state => state.communityComments.get('comments');
